import React from "react";
import "./report.css";

export default function FallDetectionReport() {
  return (
    <div className="report-container">
      <h1>Fall Detection in Videos Based on Combined Data</h1>

      <pre className="report-text">
        {`SUMMARY
• Built a robust fall detection system: silhouettes (SAM2), skeletal joint angles (MediaPipe), and center-of-mass (CoM) trajectories feed three LSTM branches; fused hidden states drive final classification. Achieved 94.7% Accuracy and 94.7% F1 on benchmark videos.

DATA & PREPROCESSING
• Training/test data include UR-Fall (RGB front-view), FDD/FFD and GMDCSA-24 subsets; frames extracted and sampled by rules (≤150→30, ≤300→60, ≤1000→120, ≤1500→240, >1500→300) to reduce redundancy, then zero-padded to uniform length; LSTM trained with pack padded sequence to ignore paddings.
• CoM computed per-frame from binary masks (formula and coordinate logs), joint angles computed from MediaPipe keypoints; silhouette masks obtained/tracked via SAM2 prompts.

MODEL
• ResNet-18 modified for single-channel silhouettes; FC replaced by identity to export embeddings; three parallel LSTMs (silhouette / joint-angle / CoM) learn temporal patterns; features concatenated and fed to FC (ReLU) with CrossEntropyLoss.

RESULTS & NOTES
• Final model (silhouette + angles + CoM) reached 94.7% accuracy and F1; RGB branch was evaluated but hurt generalization due to style shift, so excluded in final system.`}
      </pre>
    </div>
  );
}
